import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.07
    }
  }
};
const sealVariants = {
  hidden: {
    opacity: 0,
    scale: 0
  },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 15
    }
  }
};
const borderColors = ['border-crimson', 'border-cobalt', 'border-emerald', 'border-saffron'];
const rotations = ['-rotate-1', 'rotate-1', '-rotate-2', 'rotate-0', 'rotate-2', '-rotate-1', 'rotate-1', '-rotate-2', 'rotate-0', 'rotate-2', '-rotate-1', 'rotate-1', '-rotate-2', 'rotate-0', 'rotate-2', '-rotate-1'];
export function ComplianceSeals() {
  return <section className="w-full bg-midnight px-4 md:px-8 lg:px-16 py-20 md:py-32" data-id="element-37">
      <div className="max-w-7xl mx-auto" data-id="element-38">
        <h2 className="font-heading font-bold text-ivory uppercase text-3xl sm:text-4xl md:text-6xl lg:text-7xl tracking-tight mb-16 md:mb-24" data-id="element-39">
          COMPLIANCE
          <br data-id="element-40" />
          <span className="text-saffron" data-id="element-41">CERTIFICATION WALL</span>
        </h2>

        <motion.div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} data-id="element-42">
          <motion.div variants={sealVariants} className={`${rotations[0]} flex items-center justify-center`} data-id="element-43">
            <div className={`border-[3px] ${borderColors[0]} p-6 md:p-8 w-full aspect-square flex flex-col items-center justify-center text-center`} data-id="element-44">
              <span className="font-heading font-bold text-crimson text-2xl md:text-3xl" data-id="element-45">
                MGA
              </span>
              <span className="font-body text-ivory/60 text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-46">
                Malta Gaming Authority
              </span>
              <div className="w-12 h-[2px] bg-crimson mt-3" data-id="element-47" />
            </div>
          </motion.div>

          <motion.div variants={sealVariants} className={`${rotations[1]} flex items-center justify-center`} data-id="element-48">
            <div className={`border-[3px] ${borderColors[1]} p-6 md:p-8 w-full aspect-square flex flex-col items-center justify-center text-center`} data-id="element-49">
              <span className="font-heading font-bold text-cobalt text-2xl md:text-3xl" data-id="element-50">
                UKGC
              </span>
              <span className="font-body text-ivory/60 text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-51">
                UK Gambling Commission
              </span>
              <div className="w-12 h-[2px] bg-cobalt mt-3" data-id="element-52" />
            </div>
          </motion.div>

          <motion.div variants={sealVariants} className={`${rotations[2]} flex items-center justify-center`} data-id="element-53">
            <div className={`border-[3px] ${borderColors[2]} p-6 md:p-8 w-full aspect-square flex flex-col items-center justify-center text-center`} data-id="element-54">
              <span className="font-heading font-bold text-emerald text-2xl md:text-3xl" data-id="element-55">
                CUR
              </span>
              <span className="font-body text-ivory/60 text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-56">
                Curaçao eGaming
              </span>
              <div className="w-12 h-[2px] bg-emerald mt-3" data-id="element-57" />
            </div>
          </motion.div>

          <motion.div variants={sealVariants} className={`${rotations[3]} flex items-center justify-center`} data-id="element-58">
            <div className={`border-[3px] ${borderColors[3]} p-6 md:p-8 w-full aspect-square flex flex-col items-center justify-center text-center`} data-id="element-59">
              <span className="font-heading font-bold text-saffron text-2xl md:text-3xl" data-id="element-60">
                GRA
              </span>
              <span className="font-body text-ivory/60 text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-61">
                Gibraltar Regulatory Authority
              </span>
              <div className="w-12 h-[2px] bg-saffron mt-3" data-id="element-62" />
            </div>
          </motion.div>

          <motion.div variants={sealVariants} className={`${rotations[4]} flex items-center justify-center`} data-id="element-63">
            <div className={`border-[3px] ${borderColors[0]} p-6 md:p-8 w-full aspect-square flex flex-col items-center justify-center text-center`} data-id="element-64">
              <span className="font-heading font-bold text-crimson text-2xl md:text-3xl" data-id="element-65">
                IOM
              </span>
              <span className="font-body text-ivory/60 text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-66">
                Isle of Man GSC
              </span>
              <div className="w-12 h-[2px] bg-crimson mt-3" data-id="element-67" />
            </div>
          </motion.div>

          <motion.div variants={sealVariants} className={`${rotations[5]} flex items-center justify-center`} data-id="element-68">
            <div className={`border-[3px] ${borderColors[1]} p-6 md:p-8 w-full aspect-square flex flex-col items-center justify-center text-center`} data-id="element-69">
              <span className="font-heading font-bold text-cobalt text-2xl md:text-3xl" data-id="element-70">
                AGCC
              </span>
              <span className="font-body text-ivory/60 text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-71">
                Alderney GCC
              </span>
              <div className="w-12 h-[2px] bg-cobalt mt-3" data-id="element-72" />
            </div>
          </motion.div>

          <motion.div variants={sealVariants} className={`${rotations[6]} flex items-center justify-center`} data-id="element-73">
            <div className={`border-[3px] ${borderColors[2]} p-6 md:p-8 w-full aspect-square flex flex-col items-center justify-center text-center`} data-id="element-74">
              <span className="font-heading font-bold text-emerald text-2xl md:text-3xl" data-id="element-75">
                KGC
              </span>
              <span className="font-body text-ivory/60 text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-76">
                Kahnawake Gaming Commission
              </span>
              <div className="w-12 h-[2px] bg-emerald mt-3" data-id="element-77" />
            </div>
          </motion.div>

          <motion.div variants={sealVariants} className={`${rotations[7]} flex items-center justify-center`} data-id="element-78">
            <div className={`border-[3px] ${borderColors[3]} p-6 md:p-8 w-full aspect-square flex flex-col items-center justify-center text-center`} data-id="element-79">
              <span className="font-heading font-bold text-saffron text-2xl md:text-3xl" data-id="element-80">
                PAGCOR
              </span>
              <span className="font-body text-ivory/60 text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-81">
                Philippines
              </span>
              <div className="w-12 h-[2px] bg-saffron mt-3" data-id="element-82" />
            </div>
          </motion.div>

          <motion.div variants={sealVariants} className={`${rotations[8]} flex items-center justify-center`} data-id="element-83">
            <div className={`border-[3px] ${borderColors[0]} p-6 md:p-8 w-full aspect-square flex flex-col items-center justify-center text-center`} data-id="element-84">
              <span className="font-heading font-bold text-crimson text-2xl md:text-3xl" data-id="element-85">
                SGA
              </span>
              <span className="font-body text-ivory/60 text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-86">
                Swedish Gambling Authority
              </span>
              <div className="w-12 h-[2px] bg-crimson mt-3" data-id="element-87" />
            </div>
          </motion.div>

          <motion.div variants={sealVariants} className={`${rotations[9]} flex items-center justify-center`} data-id="element-88">
            <div className={`border-[3px] ${borderColors[1]} p-6 md:p-8 w-full aspect-square flex flex-col items-center justify-center text-center`} data-id="element-89">
              <span className="font-heading font-bold text-cobalt text-2xl md:text-3xl" data-id="element-90">
                ONJN
              </span>
              <span className="font-body text-ivory/60 text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-91">
                Romania
              </span>
              <div className="w-12 h-[2px] bg-cobalt mt-3" data-id="element-92" />
            </div>
          </motion.div>

          <motion.div variants={sealVariants} className={`${rotations[10]} flex items-center justify-center`} data-id="element-93">
            <div className={`border-[3px] ${borderColors[2]} p-6 md:p-8 w-full aspect-square flex flex-col items-center justify-center text-center`} data-id="element-94">
              <span className="font-heading font-bold text-emerald text-2xl md:text-3xl" data-id="element-95">
                DGOJ
              </span>
              <span className="font-body text-ivory/60 text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-96">
                Spain
              </span>
              <div className="w-12 h-[2px] bg-emerald mt-3" data-id="element-97" />
            </div>
          </motion.div>

          <motion.div variants={sealVariants} className={`${rotations[11]} flex items-center justify-center`} data-id="element-98">
            <div className={`border-[3px] ${borderColors[3]} p-6 md:p-8 w-full aspect-square flex flex-col items-center justify-center text-center`} data-id="element-99">
              <span className="font-heading font-bold text-saffron text-2xl md:text-3xl" data-id="element-100">
                ANJ
              </span>
              <span className="font-body text-ivory/60 text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-101">
                France
              </span>
              <div className="w-12 h-[2px] bg-saffron mt-3" data-id="element-102" />
            </div>
          </motion.div>

          <motion.div variants={sealVariants} className={`${rotations[12]} flex items-center justify-center`} data-id="element-103">
            <div className={`border-[3px] ${borderColors[0]} p-6 md:p-8 w-full aspect-square flex flex-col items-center justify-center text-center`} data-id="element-104">
              <span className="font-heading font-bold text-crimson text-2xl md:text-3xl" data-id="element-105">
                BMF
              </span>
              <span className="font-body text-ivory/60 text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-106">
                Germany
              </span>
              <div className="w-12 h-[2px] bg-crimson mt-3" data-id="element-107" />
            </div>
          </motion.div>

          <motion.div variants={sealVariants} className={`${rotations[13]} flex items-center justify-center`} data-id="element-108">
            <div className={`border-[3px] ${borderColors[1]} p-6 md:p-8 w-full aspect-square flex flex-col items-center justify-center text-center`} data-id="element-109">
              <span className="font-heading font-bold text-cobalt text-2xl md:text-3xl" data-id="element-110">
                AGCO
              </span>
              <span className="font-body text-ivory/60 text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-111">
                Ontario, Canada
              </span>
              <div className="w-12 h-[2px] bg-cobalt mt-3" data-id="element-112" />
            </div>
          </motion.div>

          <motion.div variants={sealVariants} className={`${rotations[14]} flex items-center justify-center`} data-id="element-113">
            <div className={`border-[3px] ${borderColors[2]} p-6 md:p-8 w-full aspect-square flex flex-col items-center justify-center text-center`} data-id="element-114">
              <span className="font-heading font-bold text-emerald text-2xl md:text-3xl" data-id="element-115">
                NJDGE
              </span>
              <span className="font-body text-ivory/60 text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-116">
                New Jersey
              </span>
              <div className="w-12 h-[2px] bg-emerald mt-3" data-id="element-117" />
            </div>
          </motion.div>

          <motion.div variants={sealVariants} className={`${rotations[15]} flex items-center justify-center`} data-id="element-118">
            <div className={`border-[3px] ${borderColors[3]} p-6 md:p-8 w-full aspect-square flex flex-col items-center justify-center text-center`} data-id="element-119">
              <span className="font-heading font-bold text-saffron text-2xl md:text-3xl" data-id="element-120">
                PGCB
              </span>
              <span className="font-body text-ivory/60 text-xs md:text-sm mt-2 uppercase tracking-wider" data-id="element-121">
                Pennsylvania
              </span>
              <div className="w-12 h-[2px] bg-saffron mt-3" data-id="element-122" />
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}